export default {
  Login: 'auth/login',
  supportedLanguage: 'supported-language',
  setLang: 'set-lang',
  fetchLangTranslation: 'languages',
  fetchBusinessType: 'business-type/fetch-business-types',
  countries: 'country/fetch-all',
  createShop: 'shop/create-shop',
  userData: 'auth/user-data',
  globalSummary: 'global-summary',
  fetchAllSales: 'sales/fetch-sales',
  logout: 'auth/logout',
  fetchUserCurrencies: 'currency/fetch-shop-currencies',
  sellItem: 'sales/record-sales',
  fetchAllProducts: 'product/fetch-stock-products',
  newProduct: 'product/add-products',
  fetchProductCategory: 'product-category/fetch-product-categories',
  financeReport: 'funds/finance-report',
  fundHistoric: 'funds/history',
  topUpMoney: 'funds/top-up',
  archivedStock: 'product/fetch-archived-products',
  renewNewProduct: 'product/rew-product-stock',
  setDefaultCurrency: 'currency/set-default-currency',
  fetchAllCurrency: 'currency/fetch-currencies',
  addCurrency: 'currency/add-shop-currency',
  expenseHistory: 'funds/expenses-history',
  recordExpense: 'funds/record-expense',
  fetchCustomers: 'clients/fetch-all-clients',
  addProductCategory: 'product-category/add-product-category',
  updateProductCategory: 'product-category/update-product-category',
  deleteProductCategory: 'product-category/delete',
  fetchProductItems: 'product/fetch-product-items',
  updateProductItem: 'product/update-product-item',
  salesAnalytics: 'analytics/sales',
  fetchLoans: 'sales/loans',
  fetchUsers: 'auth/users',
  addProductToStock: 'product/add-product-item-stock',
  loanPayment: 'sales/loan-payment',
  registerUser: 'auth/register',
  userRoles: 'user-role/fetch-user-roles',
  deleteSale: 'sales/remove-sales',
  loanPaymentHistory: 'sales/loan-payment-history',
  managePermission: 'manage-permission',
  rolePermissions: 'role-permissions',
  updateUserProfile: 'auth/update-user-profile',
  userPermissions: 'user-permissions',
  removeStockProduct: 'product/remove-stock-prod',
  resetPassword: 'auth/reset-password',
  createBranch: 'branch/create-shop-branch',
  fetchBranches: 'branch/fetch-branches',
  fetchSuppliers: 'supplier/fetch-suppliers',
  addSupplier: 'supplier/add-supplier',
  updateSupplier: 'supplier/update-supplier',
  addBranchUser: 'branch/add-branch-users',
  fetchBranchUsers: 'branch/fetch-branch-users',
  removeProductitem: 'product/remove-products',
  transferProducts: 'branch/transfer-products',
  allBranchesStock: 'branch/all-branches-stock',
  branchStockDetails: 'branch/branch-stock',
  updateBranchStock: 'branch/update-branch-stock',
  fetchBranchStock: 'branch/fetch-branch-stock-products',
  changeLanguage: 'auth/change-language',
  allInventorySummary: 'branch/all-inventory-summary',
  branchRemoveSales: 'branch/remove-sales',
  branchLoanPayment: 'branch/loan-payment',
  branchLoanPaymentHistory: 'branch/loan-payment-history',
  fetchBranchSales: 'branch/fetch-branch-sales',
  recordBranchSales: 'branch/record-branch-sales',
  removeBranchSales: 'branch/remove-branch-sales',
  fetchBranchLoan: 'sales/branch-loans',
  addManyProductCategory: 'product-category/upload-product-category',
  createExpenses: 'funds/create-expense-category',
  fetchExpenseCategory: 'funds/fetch-expense-category',
};
